import { LoadingIndicatorSpinner } from '@storeblocks/spinner-loading-indicator';
import { type FC, useEffect } from 'react';
import styled from 'styled-components';

import { useCurrentUserInfo } from '@/auth/hooks';
import { useTexts } from '@/hooks/useTexts';

import { useOrderSteps } from '../../components/OrderStepsProvider';
import { useOrderPageContext } from '../../OrderPageContext';

export const Signing: FC = () => {
  const { orders } = useTexts();
  const { completeCurrentStep } = useOrderSteps();
  const { userCmId } = useCurrentUserInfo();
  const { currentOrder } = useOrderPageContext();

  // Complete this step if the current user is not a signatory.
  useEffect(() => {
    if (!currentOrder!.signatories.includes(userCmId || '-1')) {
      // Keep currentOrder set while advancing: the completed step reads it to
      // tell the owner the order was sent to a co-signer.
      completeCurrentStep();
    }
  }, [currentOrder!.signatories]);

  return (
    <>
      <h2>{orders.form.steps.signing.title}</h2>

      <StyledLoading />
    </>
  );
};

const StyledLoading = styled(LoadingIndicatorSpinner)`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 42px;
`;
